import styled from 'styled-components';

import {
  colorSecondary,
  colorWhite,
  colorBlack,
  colorPrimary,
  colorBlack900,
  colorSecondaryBasic,
  colorPrimaryLighten95,
  colorAccentLighten95,
  colorSecondaryLighten20,
  colorBadge,
} from 'styles/variables';

import Icon from 'components/commons/Icon';

const getTypeColor = ({ type }) => {
  switch (type) {
    case 'success':
      return colorPrimaryLighten95;
    case 'info':
      return colorSecondaryLighten20;
    case 'badge':
      return colorSecondaryLighten20;
    case 'warning':
      return colorSecondaryLighten20;
    case 'default':
      return colorAccentLighten95;
    case 'danger':
      return colorSecondaryBasic;
    default:
      return colorWhite;
  }
};

export const Wrapper = styled.div`
  width: 100%;
  background-color: ${props =>
    props.outline ? 'transparent' : `1px solid ${getTypeColor(props)}`};
  border: ${props =>
    props.outline ? `1px solid ${getTypeColor(props)}` : null};
  border-radius: 2px;
  margin-bottom: 16px;
  color: ${({ type }) => {
    switch (type) {
      case 'success':
        return colorPrimary;
      case 'info':
        return colorSecondary;
      case 'badge':
        return colorBadge;
      case 'default':
        return colorBlack900;
      default:
        return colorBlack;
    }
  }};
  font-size: ${({ fontSize }) => `${fontSize}px`};
  line-height: ${({ lineHeight }) => `${lineHeight}px`};
  padding: 16px;

  ${({ border }) => {
    if (border) {
      return `
        border-${border}: 4px solid #DF3014;
      `;
    }

    return '';
  }}
`;

export const AlertIcon = styled(Icon)`
  display: inline-block;
  height: 16px;
  margin-right: 5px;
  width: 16px;
`;
